import { HttpParams } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ApiService } from '@services/api.service';

@Component({
  selector: 'ew-select-country',
  templateUrl: './select-country.component.html',
  styleUrls: ['./select-country.component.scss'],
})
export class SelectCountryComponent implements OnChanges, OnInit {
  @Input() label: string = '';
  @Input() value!: string;
  @Input() disabled: boolean = false;
  @Input() isOnboarding: boolean = false;
  @Input() isAvailableToSendPayment: boolean | null = null;
  @Input() isAvailableToCreateCompany: boolean | null = null;
  @Input() isAvailableToCreateBankAccount: boolean | null = null;
  @Input() isAvailableToSendInvoiceFunds: boolean | null = null;
  @Input() isAllowedToReceiveCorporatePayments: boolean | null = null;
  @Input() isAvailableToReceiveCommissionPayments: boolean | null = null;
  @Input() width: string = '160px';
  @Input() required: boolean = true;
  @Output() valueChanged = new EventEmitter<any>();

  countries: any[] = [];
  country: any;

  constructor(private API: ApiService) {}

  /**
   * component start
   * @author Martin Batun Tec.
   */
  ngOnInit(): void {
    let params = new HttpParams();

    if (this.isAvailableToSendPayment != null) {
      params = params.set(
        'isAvailableToSendPayment',
        this.isAvailableToSendPayment,
      );
    }
    if (this.isAvailableToCreateCompany != null) {
      params = params.set(
        'isAvailableToCreateCompany',
        this.isAvailableToCreateCompany,
      );
    }
    if (this.isAvailableToCreateBankAccount != null) {
      params = params.set(
        'isAvailableToCreateBankAccount',
        this.isAvailableToCreateBankAccount,
      );
    }
    if (this.isAvailableToSendInvoiceFunds != null) {
      params = params.set(
        'isAvailableToSendInvoiceFunds',
        this.isAvailableToSendInvoiceFunds,
      );
    }
    if (this.isAllowedToReceiveCorporatePayments != null) {
      params = params.set(
        'isAllowedToReceiveCorporatePayments',
        this.isAllowedToReceiveCorporatePayments,
      );
    }
    if (this.isAvailableToReceiveCommissionPayments != null) {
      params = params.set(
        'isAvailableToReceiveCommissionPayments',
        this.isAvailableToReceiveCommissionPayments,
      );
    }

    this.API.get('v1/public/country/', params).subscribe((data: any) => {
      this.countries = data.records;
      if (this.value) {
        this.country = this.countries.find((e) => e.iso === this.value);
      }
    });
  }

  /**
   * returns the array of step validations
   * @param changes changes inputs
   * @author Martin Batun Tec.
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.country = this.countries.find(
        (e) => e.iso == changes['value'].currentValue,
      );
    }
  }
}
